import { AccountFeatureFlag, useFeatureFlag } from '@/services/auth/feature-flags';
import { ApiTriggeredFilters } from '../components/api-triggered-filters';
import { StaleGoalsRedirect } from '../components/stale-goals-redirect';
import { useApiTriggeredTabSearch } from '../use-tab-search';

/**
 * The API-triggered tab's body, inside the Broadcasts frame, which already owns the search,
 * the tab bar and the pagination. The table goes under the filters (FPS-2629).
 */
export default function ApiTriggeredTab() {
  const showGoals = useFeatureFlag(AccountFeatureFlag.ShowGoals);
  const [search, update] = useApiTriggeredTabSearch();

  if (!showGoals && search.goalIds != null) {
    return <StaleGoalsRedirect tab="api-triggered" search={search} />;
  }

  return <ApiTriggeredFilters search={search} onChange={update} />;
}
